import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import {
    BrowserVault, Device, DeviceSecurityType, IdentityVaultConfig, Vault, VaultType
} from '@ionic-enterprise/identity-vault';
import { Platform } from '@ionic/angular';

const config: IdentityVaultConfig = {
	key: 'com.vquip.vquipos',
	type: VaultType.SecureStorage,
	deviceSecurityType: DeviceSecurityType.None,
	lockAfterBackgrounded: 2000,
	shouldClearVaultAfterTooManyFailedAttempts: true,
	customPasscodeInvalidUnlockAttempts: 2,
	unlockVaultOnLoad: false,
};
const key = 'sessionData';

export interface VaultServiceState {
	session: string;
}

@Injectable({ providedIn: 'root' })
export class VaultService {
	public state: VaultServiceState = {
		session: '',
	};

	vault: Vault | BrowserVault;
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME -
	 **-------------------------------------------------------------------------------------
	 */
	constructor(private platform: Platform) {
		this.vault =
			Capacitor.getPlatform() === 'web' ? new BrowserVault(config) : new Vault(config);
	}

	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - init
	 **-------------------------------------------------------------------------------------
	 */
	async init() {
		await this.platform.ready();
	}

	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME -
	 **-------------------------------------------------------------------------------------
	 */
	async setSession(value: string): Promise<void> {
		this.state.session = value;
		await this.vault.setValue(key, value);
	}

	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME -
	 **-------------------------------------------------------------------------------------
	 */
	async restoreSession() {
		const value = await this.vault.getValue(key);
		this.state.session = value;
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME -
	 **-------------------------------------------------------------------------------------
	 */

	async lockVault() {
		await this.vault.lock();
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME -
	 **-------------------------------------------------------------------------------------
	 */

	async unlockVault() {
		await this.vault.unlock();
	}
}
